import { Link } from 'react-router-dom';

interface PopularItem {
  slug: string;
  title: string;
  views: number;
}

interface PopularSidebarProps {
  items: PopularItem[];
}

export default function PopularSidebar({ items }: PopularSidebarProps) {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 sticky top-20">
      <div className="flex items-center gap-2 mb-5">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-fire-line text-xl text-accent-500"></i>
        </div>
        <h3 className="text-base font-bold text-foreground-950">热门排行</h3>
      </div>
      <div className="flex flex-col gap-3">
        {items.map((item, index) => (
          <Link
            key={item.slug}
            to={`/article/${item.slug}`}
            className="flex items-start gap-3 group cursor-pointer"
          >
            <span
              className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold shrink-0 mt-0.5 ${
                index === 0
                  ? 'bg-accent-500 text-background-50'
                  : index === 1
                  ? 'bg-accent-400 text-background-50'
                  : index === 2
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}
            >
              {index + 1}
            </span>
            <div className="min-w-0">
              <p className="text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                {item.title}
              </p>
              <span className="text-xs text-foreground-400 mt-1 block">
                {(item.views / 10000).toFixed(1)}万阅读
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}